import { postApi, postApiErrorMypage } from "../utils/common";

// マイページ-お問い合わせ
export const postInquiry = async (data) => {
  const urlPath = "/api/mypage/inquiry/";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorMypage(e, urlPath, postData);
  }
};
